<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Earnings",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Earnings",
            items: [
               {
                  text: "Drivers",
                  href: "/drivers",
               },  
               {
                  text: "Earnings",
                  active: true,
               },                   
            ],

            earnings: [],            
            driver_details: "",            
            cash_in_hand: "",            
            total_cash_earned: "",            
            total_mobile_earned: "",            
            total_earned: "",            
            note:'',            

            pagination: {},
            
            keyword: "",
            listing_length: 10,
            type: '',
            token: "",
            amount: "",
            payment_id: "",
            notes: "",
            driver_id: "",

            errors: {},          
            active_page_url: null,
            from: null,
            to: null,
            total: null,
            
            
         };
      },
      mounted() {
    
      },
      created() {
         this.fetchEarnings();

      },
      methods: {
         fetchEarnings(page_url = null) {

            let url = "fuelstation/fuel_station/driver/earnings?id=" + this.$route.params.id + "&keyword="  + this.keyword + "&limit=" + this.listing_length+ "&type=" + this.type;         
            this.getToken();
            page_url = page_url || url;

            this.active_page_url = page_url;
            this.loading = true;


            this.$axios
            .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               if(res.status == 200) {

               var responseData = res.data.data;
               console.log(responseData);
               this.earnings = responseData.payments.data; 
               this.driver_details = responseData.driver_details; 
               this.cash_in_hand = responseData.cash_in_hand; 
               this.total_cash_earned = responseData.total_cash_earned; 
               this.total_mobile_earned = responseData.total_mobile_earned; 
               this.total_earned = responseData.total_earned; 
               this.driver_id = responseData.driver_details.user_id; 

               this.pagination = responseData.payments.links;
               this.from = responseData.payments.from;
               this.to = responseData.payments.to;
               this.total = responseData.payments.total;
               }
                     
            })
            .catch((error) => {
            console.log(error);
            console.log(error.response);
            if (error.response) {
               if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  } 
                  this.$swal("", error.response.statusText, "error");
                  
               } else if(error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");
               } 
               else if(error.response.status == 401) {
                  this.$swal("", error.response.statusText, "error");
                  this.$router.push({ name: "login" });
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            } else {
               this.$swal("", error.message, "error");
            }

            });
            //.finally(() => (this.loading = false));
            },
            getToken() {
               if (localStorage.getItem('sigofuel_fuelstation')) {
               var sigofuel_fuelstation =  JSON.parse(localStorage.getItem('sigofuel_fuelstation'));
               if(sigofuel_fuelstation.token) {
                  this.token = sigofuel_fuelstation.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
                  
               } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
               }
               },
               showModal(modal) {
            this.$refs[modal].show();
         },
         updatePayment() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "fuelstation/fuel_station/addPayment";

            let formData = new FormData();
           
            formData.append("driver_id", this.driver_id); 
            formData.append("amount", this.amount); 
            formData.append("payment_id", this.payment_id); 
            formData.append("notes", this.notes); 

         //alert(this.updatestock.fuel_type_id);
           
            this.$axios
            .post(url, formData, config)
            .then((response) => {
               if(response.status == 200) {
                     this.$swal("", response.data.message, "success");
                
                  this.hideModal('payment-modal');
               }
               })
               .catch((error) => {
            console.log(error);
            console.log(error.response);
            if (error.response) {
               if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  } 
                  this.$swal("", error.response.statusText, "error");
                  
               } else if(error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");
               } 
               else if(error.response.status == 401) {
                  this.$swal("", error.response.statusText, "error");
                  this.$router.push({ name: "login" });
               } else if(error.response.status == 402) {
                  this.$swal("", error.response.data.message, "error");
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            } else {
               this.$swal("", error.message, "error");
            }
            
         });
            //.finally(() => (this.loading = false));
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },
         viewNote(notes) {
            this.note = notes;
            this.showModal("note-modal");
         },

         clearForm() {
            this.note = '';
         }
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <router-link :to="{ name: 'drivers' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <div class="row">
                     <div class="col-3">
                        <b-media class="mb-4">
                           <template v-slot:aside>
                              <img v-if="driver_details.image" :src="$image_url + driver_details.image" alt
                                       class="avatar-sm rounded-circle">
                                       <img v-else src="@/assets/images/no-user.jpg"
                                       alt
                                       class="avatar-sm rounded-circle"
                                       />                                <br>
                           </template>
                           <b-media-body class="ms-3">
                              <h5 class="mt-1 mb-1">{{driver_details.name_en}}<br>{{driver_details.name_so}}</h5>
                              <p>
                                 {{driver_details.country_code}} {{driver_details.mobile}}<br>
                                 {{driver_details.email}}
                              </p>
                           </b-media-body>
                        </b-media>
                     </div>
                     <div class="col-lg-5 ">
                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h6 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 px-3 py-2 mb-3"> Total Earnings <br><br><span v-if="total_earned">${{total_earned}}</span>
                                             <span v-else>$0</span></h6>
                           <div class="table-responsive ">
                                 <table class="table table-nowrap mb-0">
                                    <tbody>
                                        <tr width="50%">
                                          <th scope="row">Mobile Payment</th>
                                          <th>:</th>
                                          <td><span v-if="total_mobile_earned">${{total_mobile_earned}}</span>
                                             <span v-else>$0</span></td>
                                       </tr>
                                       <tr width="50%">
                                          <th scope="row">Cash Payment</th>
                                          <th>:</th>
                                          <td><span v-if="total_cash_earned">${{total_cash_earned}}</span>
                                             <span v-else>$0</span></td>
                                       </tr>
                                    </tbody>
                                 </table>
                           </div>
                        </b-card>
                     </div>
                     <div class="col-lg-4">
                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h5 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 px-3 py-2 mb-3"> Amount in hand <br><br><span v-if="cash_in_hand">${{cash_in_hand}}</span>
                                             <span v-else>$0</span></h5>
                        </b-card>     
                        <b-button v-b-modal.payment-modal variant="primary" class="float-end">Add Payment</b-button>                  
                     </div>
                  </div> 

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchEarnings()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchEarnings()"/>
                           </label>
                        </div>                     
                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="type"  @change="fetchEarnings()">    
                                 <option value="">All</option>
                                 <option value="1">Credit</option>
                                 <option value="2">Debit</option>
                                 
                              </select>
                           </label>
                        </div>   
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                 <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th>SI No.</th> 
                              <th>Credit</th>  
                              <th>Debit</th>
                              <th>Payment Type</th>
                              <th>Order ID</th>
                              <th>Payment ID</th>
                              <th>Notes</th>
                              <th>Created On</th>
                              <!-- <th>Total</th> -->
                              
                              <th>Options</th>
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(earnings.length)">
                           <tr v-for="(earning,index) in earnings" :key="earning.id">
                              <td>{{index + from}}</td>
                              <td><span v-if="earning.type==1">${{earning.amount}}</span>
                                             <span v-else>-</span></td>
                              <td><span v-if="earning.type==2">${{earning.amount}}</span>
                                             <span v-else>-</span></td>
                              <td><span v-if="earning.payment_type==2">Cash</span>
                                             <span v-else>Mobile</span></td>
                              <td><span v-if="earning.order_id">#{{earning.order_id}}</span>
                                             <span v-else>-</span></td>
                              <td><span v-if="earning.payment_id">#{{earning.payment_id}}</span>
                                             <span v-else>-</span></td>  
                              <td><span v-if="earning.notes">{{earning.notes | excerpt(50)}}<br><a href="#" v-if="earning.notes.length > 50" @click.prevent="viewNote(earning.notes)" >Read More</a></span>
                                             <span v-else>-</span></td> 
                              <td>{{earning.created_at | formatDateTime }}</td>
                              <!-- <td>{{earning.total}}</td> -->
                              <td v-if="earning.type==1">
                                 <router-link :to="{ name: 'orders.details', params: {id: earning.order_id} }" class="btn btn-primary me-2 mb-2 btn-sm">Order Details</router-link>
                              </td>    
                           </tr>
                 
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="5" class="text-center">No Earnings found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                 <!----pagination starts ---> 
                <caption v-if="Boolean(earnings.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchEarnings(page.url + '&limit='+ listing_length + '&keyword=' + keyword + '&type=' + type + '&id=' + $route.params.id)">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->

                  <!---- modal starts ---->
                  <b-modal ref="note-modal" id="note-modal" title="View Notes" hide-footer @hidden="clearForm()">
                     <b-form>
                        
                        <b-col md="12">
                           <card class="p-3">
                              <p>{{note}}</p>
                           </card>
                        </b-col>                   
                        
                        <b-col md="12">                           
                           <b-button class="" variant="light" @click="$bvModal.hide('note-modal')">Close</b-button>
                        </b-col>
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->

                  <!---- modal starts ---->
                  <b-modal ref="payment-modal" id="payment-modal" title="Update Payment" hide-footer>
                     <b-form @submit.prevent="updatePayment()">
                        <b-row>                

                           <b-col lg="12" class="form-group">
                              <label class="control-label">Amount <span class="text-danger">*</span></label>
                              <b-form-input type="number" step="any" v-model="amount" v-bind:class="{ 'is-invalid': Boolean(errors.amount)}"></b-form-input>
                              <div v-for="(val, index) in errors.amount" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                          
                           </b-col>   

                           <b-col lg="12" class="form-group">
                              <label class="control-label">Payment ID <span class="text-danger">*</span></label>
                              <b-form-input type="text" v-model="payment_id" v-bind:class="{ 'is-invalid': Boolean(errors.payment_id)}"></b-form-input>
                              <div v-for="(val, index) in errors.payment_id" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>   
                              </b-col>   

                           <b-col lg="12" class="form-group">
                              <label class="control-label">Notes </label>
                              <b-form-textarea rows="3" v-model="notes" v-bind:class="{ 'is-invalid': Boolean(errors.notes)}"></b-form-textarea>
                                  <div v-for="(val, index) in errors.notes" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div> 
                           </b-col>
                           
                           <b-col lg="12">
                              <b-button type="submit" class="me-3" variant="primary">Update</b-button>
                              <b-button class="" variant="light" @click="$bvModal.hide('payment-modal')">Close</b-button>
                           </b-col>
                        </b-row>
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->         


               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
